import { useEffect } from "react";
import { sanitizeFoxpostFindme, sanitizeFoxpostHtml } from "./checkoutUtils";

const FOXPOST_FINDER_URL = "https://cdn.foxpost.hu/apt-finder/v1/app/";

function normalizeFoxpostApt(apt) {
  return {
    ...apt,
    name: sanitizeFoxpostHtml(apt.name),
    address: sanitizeFoxpostHtml(apt.address),
    findme: sanitizeFoxpostFindme(apt.findme),
  };
}

function FoxpostPickupPicker({ t, selected, onSelect }) {
  useEffect(() => {
    function receiveMessage(event) {
      if (event.origin !== "https://cdn.foxpost.hu") return;

      try {
        const apt =
          typeof event.data === "string" ? JSON.parse(event.data) : event.data;
        if (!apt || typeof apt !== "object") return;
        onSelect(normalizeFoxpostApt(apt));
      } catch {
        // ignore non-JSON messages
      }
    }

    window.addEventListener("message", receiveMessage, false);
    return () => window.removeEventListener("message", receiveMessage, false);
  }, [onSelect]);

  return (
    <div className="checkout-map-picker">
      {selected ? (
        <div className="checkout-selected-point" role="status">
          <p className="checkout-selected-point-name">{selected.name}</p>
          <p className="checkout-selected-point-address">{selected.address}</p>
          {selected.findme ? (
            <p className="checkout-selected-point-note">{selected.findme}</p>
          ) : null}
        </div>
      ) : null}
      <iframe
        title={t.foxpostMapTitle}
        className="checkout-map-iframe checkout-map-iframe--foxpost"
        src={FOXPOST_FINDER_URL}
        loading="lazy"
      />
    </div>
  );
}

export default FoxpostPickupPicker;
